import { GraphQLInputObjectType, GraphQLObjectType, GraphQLString } from 'graphql';

import { TypeNames } from '../../types';

const User = new GraphQLObjectType({
	fields: {
		id: { type: GraphQLString },
		fullName: { type: GraphQLString },
		nickname: { type: GraphQLString },
		timezone: { type: GraphQLString },
		locale: { type: GraphQLString },
		avatarUrl: { type: GraphQLString },
		email: { type: GraphQLString },
		status: { type: GraphQLString },
		// extended profile
		title: { type: GraphQLString },
		companyName: { type: GraphQLString },
		department: { type: GraphQLString },
		location: { type: GraphQLString },
		phoneNumber: { type: GraphQLString },

		// This should be considered to move to component level that uses timezone
		localTime: {
			type: GraphQLString,
			args: {
				format: {
					description: 'moment.js format string',
					type: GraphQLString,
					defaultValue: '',
				},
				locale: {
					description: 'locale for output',
					type: GraphQLString,
					defaultValue: 'en',
				},
			},
		},
	},
	name: TypeNames.USER,
	description: 'All User related data will be behind this GraphQL section',
});

export default User;

export const UserInput = new GraphQLInputObjectType({
	fields: {
		fullName: { type: GraphQLString },
		nickname: { type: GraphQLString },
		timezone: { type: GraphQLString },
		locale: { type: GraphQLString },
		email: { type: GraphQLString },
		status: { type: GraphQLString },
		// extended profile
		title: { type: GraphQLString },
		companyName: { type: GraphQLString },
		department: { type: GraphQLString },
		location: { type: GraphQLString },
		phoneNumber: { type: GraphQLString },
	},
	name: TypeNames.USER_INPUT,
});
